const getOffset = (elem) => {
	let distance = 0;

	if (elem == null) return 0;

	if (elem.offsetParent) {
		do {
			distance += elem.offsetTop;
			elem = elem.offsetParent;
		} while (elem);
	}

	return distance < 0 ? 0 : distance;
};

export default getOffset;


// WEBPACK FOOTER //
// ./assets/js/partials/helpers/get_offset.js